export default {
  SET_KVKK: "SET_KVKK",
  SET_TERMS_OF_USE: "SET_TERMS_OF_USE",
  SET_DISTANCE_SELLING_AGREEMENT: "SET_DISTANCE_SELLING_AGREEMENT",
  SET_COMMERCIAL_MAIL_CONFIRMATION: "SET_COMMERCIAL_MAIL_CONFIRMATION",
};
